import ApiService from "../api/ApiService";
import Config from "../constants/Config";
import PackageRate from "../models/PackageRate";
import Urls from "../api/Urls";
import PackageRateDescription from "../models/PackageRateDescription";
import PackageRateProduction from './../models/PackageRateProduction';

export function getPackageRateList(data) {
  return new ApiService({
    baseURL: Config.API_HOTEL,
    endpoint: Urls.PACKAGE_RATE_LIST,
    parser: (data) => PackageRatesDataParser(data),
    params: data,
    timeout: 60000,
  }).get();
}

export function updatePackageRateActive(id, data) {
  return new ApiService({
    baseURL: Config.API_HOTEL,
    endpoint: Urls.PACKAGE_RATE_UPDATE_ACTIVE,
    params: { id }
  }).post(data);
}

export function deletePackageRate(id) {
  return new ApiService({
    baseURL: Config.API_HOTEL,
    endpoint: Urls.PACKAGE_RATE_UPDATE,
    endpointParams: { id }
  }).delete();
}

export function clonePackageRate(id) {
  return new ApiService({
    baseURL: Config.API_HOTEL,
    endpoint: Urls.PACKAGE_RATE_CLONE,
    params: { id }
  }).post();
}

export function getPackageRateDetail(id) {
  return new ApiService({
    baseURL: Config.API_HOTEL,
    endpoint: Urls.PACKAGE_RATE_DETAIL,
    endpointParams: { id },
    parser: (data) => {
      return new PackageRate({ ...data, hotelId: id });
    },
  }).get();
}

export function updatePackageRate(data, id) {
  return new ApiService({
    baseURL: Config.API_HOTEL,
    endpoint: Urls.PACKAGE_RATE_UPDATE,
    endpointParams: { id },
  }).put(data);
}

export function createPackageRate(data) {
  return new ApiService({
    baseURL: Config.API_HOTEL,
    endpoint: Urls.PACKAGE_RATE_CREATE,
  }).post(data);
}

export function updatePackageRateTranslate(data) {
  return new ApiService({
    baseURL: Config.API_HOTEL,
    endpoint: Urls.PACKAGE_RATE_TRANSLATE,
  }).put(data);
}

export function createPackageRateTranslate(data) {
  return new ApiService({
    baseURL: Config.API_HOTEL,
    endpoint: Urls.PACKAGE_RATE_TRANSLATE,
  }).post(data);
}

export function getPackageRatteTranslate(id) {
  return new ApiService({
    baseURL: Config.API_HOTEL,
    endpoint: Urls.PACKAGE_RATE_TRANSLATE_DETAIL,
    endpointParams: { id },
    parser: (data) => {
      return new PackageRateDescription(data);
    },
  }).get(id);
}

export function createPackageRateProduct(id, data) {
  return new ApiService({
    baseURL: Config.API_HOTEL,
    endpoint: Urls.PACKAGE_RATE_PRODUCT_UPDATE,
    endpointParams: { id },
  }).post(data);
}

export function updatePackageRateProduct(id, data) {
  return new ApiService({
    baseURL: Config.API_HOTEL,
    endpoint: Urls.PACKAGE_RATE_PRODUCT_UPDATE,
    endpointParams: { id },
  }).put(data);
}

export function getPackageRateProduct(id) {
  return new ApiService({
    baseURL: Config.API_HOTEL,
    endpoint: Urls.PACKAGE_RATE_PRODUCT_DETAIL,
    endpointParams: { id },
    parser: (data) => {
      return new PackageRateProduction(data);
    },
  }).get(id);
}

const PackageRatesDataParser = (data) => ({
  ...data,
  packageRates : (data.packageRates || []).map((item) => new PackageRate(item)),
});
